'use strict';

/**
* RadioButton custom element.
*/
JQX('jqx-radio-button', function (_JQX$ToggleButton) {
    babelHelpers.inherits(RadioButton, _JQX$ToggleButton);

    function RadioButton() {
        babelHelpers.classCallCheck(this, RadioButton);
        return babelHelpers.possibleConstructorReturn(this, (RadioButton.__proto__ || Object.getPrototypeOf(RadioButton)).apply(this, arguments));
    }

    babelHelpers.createClass(RadioButton, [{
        key: 'template',


        /** RadioButton's Html template. */
        value: function template() {
            return '<div  id=\'container\' class=\'jqx-container\'>\n                 <div id=\'radioButtonAnimation\' class =\'jqx-animation\'></div>\n                 <span id=\'radioButtonInput\' class =\'jqx-input\'></span>\n                 <span id=\'radioButtonLabel\' inner-h-t-m-l=\'[[innerHTML]]\' class =\'jqx-label\'><content></content></span>\n                 <input id=\'hiddenInput\' class =\'jqx-hidden-input\' type=\'hidden\'>\n               </div>';
        }
    }, {
        key: 'ready',


        /** Called when the element is ready. Used for one-time configuration of the Checkbox. */
        value: function ready() {
            var that = this;

            babelHelpers.get(RadioButton.prototype.__proto__ || Object.getPrototypeOf(RadioButton.prototype), 'ready', this).call(this);
            that._updateHidenInputNameAndValue();
        }

        /**
         * Radio button down handler.
         */

    }, {
        key: '_downHandler',
        value: function _downHandler() {
            var that = this;

            if (that.disabled || that.readonly) {
                return;
            }

            if (that._preventAction) {
                that._preventAction = false;
                return;
            }

            if (that.clickMode === 'release' || that.clickMode === 'pressAndRelease') {
                that._pressed = true;
            }

            if (that.clickMode === 'press' || that.clickMode === 'pressAndRelease') {
                if (that.clickMode === 'pressAndRelease') {
                    if (that.groupName === '') {
                        that._checkedBeforeChange = that.parentNode.querySelector('jqx-radio-button[checked]');
                    } else {
                        that._checkedBeforeChange = document.querySelector('jqx-radio-button[group-name="' + that.groupName + '"][checked]');
                    }
                }

                that._handleMouseInteraction();
            }
        }

        /**
         * Radio button mouseenter handler.
         */

    }, {
        key: '_mouseenterHandler',
        value: function _mouseenterHandler() {
            var that = this;

            if (that.clickMode === 'hover' && !that.disabled && !that.readonly) {
                that._handleMouseInteraction();
            }
        }

        /**
         * Radio button label down handler.
         */

    }, {
        key: '_radioButtonLabelDownHandler',
        value: function _radioButtonLabelDownHandler(event) {
            var that = this;

            if (!that.enableContainerClick) {
                that._preventAction = true;
            }
            event.stopPropagation();
        }

        /**
         * Document up handler.
         */

    }, {
        key: '_documentUpHandler',
        value: function _documentUpHandler() {
            var that = this;

            if (!that._pressed) {
                return;
            }

            if (that.clickMode === 'release') {
                that._handleMouseInteraction();
            } else {
                // clickMode: 'pressAndRelease'
                if (that._checkedBeforeChange === null) {
                    that.$.fireEvent('change', { 'value': false, 'oldValue': true, 'changeType': 'pointer' });
                    that.checked = false;
                } else {
                    that._checkedBeforeChange._changeCheckState('pointer');
                }

                that.focus();
                that._updateHidenInputNameAndValue();
            }

            that._pressed = false;
        }

        /**
         * Handles interaction with the mouse.
         */

    }, {
        key: '_handleMouseInteraction',
        value: function _handleMouseInteraction() {
            var that = this;

            that._handleTextSelection();

            that._changeCheckState('pointer');
            that.focus();
            that._updateHidenInputNameAndValue();
        }

        /** Changes the check state. */

    }, {
        key: '_changeCheckState',
        value: function _changeCheckState(changeType) {
            var that = this;

            var radioButtonsGroup = document.querySelectorAll('jqx-radio-button[group-name="' + that.groupName + '"]');

            if (that.checked === false) {
                if (radioButtonsGroup.length > 0) {
                    that._changeCheckStateInGroup(radioButtonsGroup, changeType);
                } else {
                    var parent = that.parentNode;
                    radioButtonsGroup = parent.querySelectorAll('jqx-radio-button:not([group-name])');
                    that._changeCheckStateInGroup(radioButtonsGroup, changeType);
                }
            }
        }

        /** Changes the check states in group of radio buttons. */

    }, {
        key: '_changeCheckStateInGroup',
        value: function _changeCheckStateInGroup(elements, changeType) {
            var that = this;

            for (var i = 0; i < elements.length; i++) {
                var radioButton = elements[i];
                radioButton._isUpdating = true;
            }

            for (var _i = 0; _i < elements.length; _i++) {
                var _radioButton = elements[_i];
                if (_radioButton === that.$.element) {
                    that.checked = true;
                    that.$.fireEvent('change', { 'value': true, 'oldValue': false, 'changeType': changeType });
                } else if (_radioButton.checked === true) {
                    _radioButton.checked = false;
                    that.$.fireEvent('change', { 'value': false, 'oldValue': true, 'changeType': 'api' });
                }
            }

            for (var _i2 = 0; _i2 < elements.length; _i2++) {
                var _radioButton2 = elements[_i2];
                _radioButton2._isUpdating = false;
            }
        }

        /**
        * Updates the radio button/radio group when checked property is changed.
        * @param {string} propertyName The name of the property.
        * @param {number/string} oldValue The previously entered value. Max, min and value are of type Number. The rest are of type String.
        * @param {number/string} newValue The new entered value. Max, min and value are of type Number. The rest are of type String.
        */

    }, {
        key: 'propertyChangedHandler',
        value: function propertyChangedHandler(propertyName, oldValue, newValue) {
            babelHelpers.get(RadioButton.prototype.__proto__ || Object.getPrototypeOf(RadioButton.prototype), 'propertyChangedHandler', this).call(this, propertyName, oldValue, newValue);

            var that = this;

            switch (propertyName) {
                case 'value':
                    that._updateHidenInputNameAndValue();
                    break;
                case 'checked':
                    if (!that._isUpdating) {
                        that._changeCheckState('api');
                    }
                    that._updateHidenInputNameAndValue();
                    break;
                case 'name':
                    that._updateHidenInputName();
                    break;
            }
        }
    }], [{
        key: 'properties',

        // RadioButton's properties.
        get: function get() {
            return {
                'groupName': {
                    value: '',
                    type: 'string'
                },
                'enableContainerClick': {
                    value: false,
                    type: 'boolean'
                }
            };
        }
    }, {
        key: 'listeners',
        get: function get() {
            return {
                'down': '_downHandler',
                'mouseenter': '_mouseenterHandler',
                'radioButtonLabel.down': '_radioButtonLabelDownHandler',
                'document.up': '_documentUpHandler'
            };
        }
    }]);
    return RadioButton;
}(JQX.ToggleButton));